import React from 'react';
import {Content, Container, DataContainer} from 'app/components/matchEvents/MatchEventStyles';
import {COLORS, IconBadge, Image, SIZES, Typography} from '@fupa/fupa-uikit';
import {ArrowDown, ArrowUp} from 'app/components/icons';
import MatchEventMinute from 'app/components/matchEvents/MatchEventMinute';
import {FlexContainer} from 'app/styles/content';
import ProfileImageFallbackIcon from 'app/styles/ProfileImageFallbackIcon';
import styled from 'styled-components';

const RelativeContainer = styled.div`
  position: relative;
`;

const OuterWrapper = styled(FlexContainer)`
  gap: ${SIZES['12']};
`;

const ImageWrapper = styled(FlexContainer)`
  gap: ${SIZES['8']};
`;

const TextWrapper = styled(FlexContainer)`
  flex-direction: column;
`;

const GreenArrowUp = styled(ArrowUp)`
  color: ${COLORS.green};
  font-size: ${SIZES['12']};
`;

const RedArrowDown = styled(ArrowDown)`
  color: ${COLORS.red};
  font-size: ${SIZES['12']};
`;

const IMAGE_SIZE = 56;
const StyledProfileImageFallbackIcon = styled(ProfileImageFallbackIcon)`
  background: ${COLORS.lightestGrey};
  border-radius: 100%;
  font-size: ${SIZES[IMAGE_SIZE]};
`;
const MatchEventSubstitution = ({event}) => {
  let subIn =
    event.primaryRole && event.primaryRole.player
      ? `${event.primaryRole.player.firstName} ${event.primaryRole.player.lastName}`
      : 'Unbekannter Spieler';
  let subOut =
    event.secondaryRole && event.secondaryRole.player
      ? `${event.secondaryRole.player.firstName} ${event.secondaryRole.player.lastName}`
      : 'unbekannten Spieler';
  const substitution = `${subIn} für ${subOut}`;
  const standingMessage = `Wechsel 🔄 bei ${event.team?.name?.middle ?? 'nicht angegebenem Team'}`;
  const time = event.additionalMinute > 0 ? `${event.minute}'+${event.additionalMinute}` : `${event.minute}'`;
  const fallbackPlayerImage = <StyledProfileImageFallbackIcon />;

  const playerImageIn = event.primaryRole?.player?.image ? (
    <Image
      entity='player'
      src={event.primaryRole.player.image}
      ratio='1:1'
      width={IMAGE_SIZE}
      height={IMAGE_SIZE}
      circle={true}
    />
  ) : (
    fallbackPlayerImage
  );
  const playerImageOut = event.secondaryRole?.player?.image ? (
    <Image
      entity='player'
      src={event.secondaryRole.player.image}
      ratio='1:1'
      width={IMAGE_SIZE}
      height={IMAGE_SIZE}
      circle={true}
    />
  ) : (
    fallbackPlayerImage
  );
  return (
    <Content>
      <Container>
        <MatchEventMinute minute={time} />
        <DataContainer>
          <OuterWrapper>
            <ImageWrapper>
              <RelativeContainer>
                <IconBadge value={<GreenArrowUp />} position={2} />
                {playerImageIn}
              </RelativeContainer>
              <RelativeContainer>
                <IconBadge value={<RedArrowDown />} position={3} />
                {playerImageOut}
              </RelativeContainer>
            </ImageWrapper>
            <TextWrapper>
              <Typography variant='body1'>{standingMessage}</Typography>
              <Typography variant='body2'>{substitution}</Typography>
            </TextWrapper>
          </OuterWrapper>
        </DataContainer>
      </Container>
    </Content>
  );
};

export default MatchEventSubstitution;
